// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__2YQUH","name":"ConsentHeader_name__3UJtQ","birthday":"ConsentHeader_birthday__Y2D11","skeleton":"ConsentHeader_skeleton__5cFQ1"};